module.exports = __webpack_public_path__ + "static/media/setup_run.bef7046d.gif";